module.exports = __webpack_public_path__ + "static/media/rupeshkumar.0f20c321.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/rupeshkumar.webp
// module id = 358
// module chunks = 0